import { render, staticRenderFns } from "./addSuperUser.vue?vue&type=template&id=fd065ca8&lang=pug"
import script from "./addSuperUser.vue?vue&type=script&lang=js"
export * from "./addSuperUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports